import * as React from "react";

function SvgScan(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 34" fill="none" {...props}>
      <path
        d="M4.25 0a2.833 2.833 0 00-2.833 2.833v8.5H4.25V4.25c0-.782.634-1.417 1.417-1.417h4.25V0H4.25zM22.667 0v2.833H25.5c.782 0 1.417.635 1.417 1.417v7.083h2.833v-8.5A2.833 2.833 0 0026.917 0h-4.25zM29.75 22.667h-2.833v7.083c0 .782-.635 1.417-1.417 1.417h-4.25V34h5.667a2.833 2.833 0 002.833-2.833v-8.5zM9.917 34v-2.833h-4.25A1.417 1.417 0 014.25 29.75v-7.083H1.417v8.5A2.833 2.833 0 004.25 34h5.667zM0 15.583h31.167v2.834H0v-2.834z"
        fill="#FFF"
      />
    </svg>
  );
}

export default SvgScan;
